export default __webpack_public_path__ + "static/media/paper-clip.1be98fb9.svg";